import styled from "@emotion/styled"
import { Container, Grid, Typography } from "@mui/material"
import { GlobalContext } from "common/GlobalContext"
import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import VehicleModel from "components/Vehicle/VehicleModel"
import { useContext } from "react"

const Styled = {
  Wrapper: styled.div`
    padding: 0 0 50px;

    ${(p) => p.theme.breakpoints.up("md")} {
      padding: 0 28px 70px;
    }
  `,
  Header: styled(Typography)`
    font-size: 22px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
    padding: 20px;

    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 41px;
      text-align: center;
      padding: 30px 0 0;
    }

    ${(p) => p.theme.breakpoints.down("sm")} {
      box-shadow: 0 10px 20px 0 ${(p) => p.theme.colors.darkIndigo};
      margin-bottom: 20px;
    }
  `,
}

export const getStaticProps = StaticPropsFactory("models")

const Models = ({ seo }: StaticPropsFactoryProps) => {
  const { models } = useContext(GlobalContext)
  return (
    <Styled.Wrapper>
      <SeoMetaData data={seo} />
      <Container disableGutters>
        <Styled.Header variant="h1">הדגמים שלנו</Styled.Header>
        <Grid container>
          {models.map((model, i) => (
            <Grid item key={i} lg={6} md={6} sm={12} xs={12}>
              <VehicleModel model={model} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Styled.Wrapper>
  )
}

export default Models
